import { useEffect, useState } from 'react';
import type { MutableRefObject } from 'react';

export const useIntersection = (
  enabled: boolean,
  element: MutableRefObject<HTMLDivElement | null>,
  rootMargin: string,
  intersectionOnce: boolean
) => {
  const [isVisible, setState] = useState(!enabled);

  useEffect(() => {
    if (enabled) {
      const observedElement = element.current;

      const observer = new IntersectionObserver(
        ([entry]) => {
          setState(current => intersectionOnce && current ? current : entry.isIntersecting);

          if (intersectionOnce && entry.isIntersecting) {
            if (observedElement) {
              observer.unobserve(observedElement);
            }
          }
        },
        { rootMargin }
      );

      if (observedElement) {
        observer.observe(observedElement);
      }

      return () => {
        if (observedElement) {
          observer.unobserve(observedElement);
        }
      };
    }

    return undefined;
  }, []);

  return isVisible;
};
